module.exports = __webpack_public_path__ + "img/paris.6ebd8d79.jpg";